import { render, staticRenderFns } from "./calendar-view.vue?vue&type=template&id=5fd61d1a&"
import script from "./calendar-view.vue?vue&type=script&lang=js&"
export * from "./calendar-view.vue?vue&type=script&lang=js&"
import style0 from "./calendar-view.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports